<template>
  <div class="app">
    <div class="w100">
      <div class="title">
        <h4>商务合作</h4>
        <div>
          <p v-for="(item, index) in Msg" :key="index">{{item}}</p>
        </div>
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="top"
      label-width="150px"
      class="submitform"
    >
      <el-form-item
        label="公司名称"
        prop="company"
        :rules="{
          required: true, message: '公司名称不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="ruleForm.company" placeholder="请填写您的公司名称"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人"
        prop="name"
        :rules="{required: true, message: '联系人不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="ruleForm.name" placeholder="请填写联系人的姓名"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱"
        prop="mail"
        :rules="[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
        ]"
      >
        <el-input v-model="ruleForm.mail" placeholder="请填写您的电子邮箱"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model.number="ruleForm.phone" placeholder="请填写您的手机号"></el-input>
      </el-form-item>
      <el-form-item
        label="需求概述"
        prop="note"
        :rules="[
           { required: true, message: '请简略描述您的需求', trigger: 'blur' }
        ]"
      >
        <el-input type="textarea" :rows="11" placeholder="请简要描述您的需求" v-model="ruleForm.note"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="issubmit" @click="submitForm('ruleForm')">发送合作意向</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { filePost } from '@/api/http.js'
import EQ from '@/components/common/js/eqObject'
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      ruleForm: {
        company: '',
        name: '',
        mail: '',
        phone: '',
        model: '',
        time: '',
        budget: '',
        note: ''
      },
      issubmit: false,
      Msg: ['您发送给我们的合作意向非常重要，为了保证商务合作的严谨与高效，请准确填写下表。', '收到您的合作意向后，我公司商务人员会主动与您联系。合作达成时，我们会为您提供优质', '的技术与产品服务，期待您的来访。'],
      rules: {
        phone: [
          { validator: checkPhone, trigger: 'blur', required: true }
        ]
      },
      oldSubmit: null
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let checkdata = {}
          let formdata = new FormData()
          formdata.append('budget', this.ruleForm.budget)
          formdata.append('companyName', this.ruleForm.company)
          formdata.append('contacts', this.ruleForm.name)
          formdata.append('email', this.ruleForm.mail)
          formdata.append('need', this.ruleForm.note)
          formdata.append('phone', this.ruleForm.phone)
          formdata.append('serviceModeEnum', this.ruleForm.model)
          formdata.append('startTime', this.ruleForm.time)
          formdata.append('files', [])
          checkdata['budget'] = this.ruleForm.budget
          checkdata['companyName'] = this.ruleForm.company
          checkdata['contacts'] = this.ruleForm.name
          checkdata['email'] = this.ruleForm.mail
          checkdata['need'] = this.ruleForm.note
          checkdata['phone'] = this.ruleForm.phone
          checkdata['serviceModeEnum'] = this.ruleForm.model
          checkdata['startTime'] = this.ruleForm.time
          if (!EQ(checkdata, this.oldSubmit)) {
            this.issubmit = true
            this.$message.success('正在发送中')
            filePost('apply/save', formdata, {}).then((el) => {
              if (el.success === true) {
                this.$message.success('申请发送成功')
                this.oldSubmit = checkdata
              } else {
                this.$message.error('申请发送失败!')
              }
            }).catch(er => {
              this.$message.error('提交出错')
            })
            this.issubmit = false
          } else {
            console.log('重复提交')
            this.$message.success('您填写的信息已收到')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.app /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 72px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  text-align: left;
}
.app /deep/ .el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}
.app /deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(254, 245, 255, 1);
}
.app /deep/ .el-button--primary {
  width: 491px;
  height: 80px;
  background: rgba(74, 17, 118, 1);
  border: 0px;
  border-radius: 6px;
  margin-top: 107px;
  margin-bottom: 87px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.app /deep/ .el-form-item {
  margin-bottom: 22px;
  text-align: left;
}
.app /deep/ .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: 20px;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  text-align: left;
}
.app /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  line-height: 70px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 24px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.app /deep/ .el-select-dropdown__item {
  font-size: 20px;
  padding: 4px 21px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 55px;
  line-height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
/* .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    -webkit-transition: all .3s;
    transition: all .3s;
    line-height: 40px;
} */

.app .w100 .title p {
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-bottom: -25px;
}
.app .w100 .title :nth-child(2) :first-child {
  text-indent: 2em;
}
.app .w100 .title :last-child {
  margin-bottom: 30px;
  width: 990px;
}
</style>

<style >
.el-message {
  min-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/cooperateForm.vue